require('./company-pages.route');
require('./company-pages.controller');
require('./new-company-page.controller');
